import DecryptagePedagogicArticle from './DecryptagePedagogicArticle.model';

export default class Pedagogic {
  constructor({
    total,
    results,
  }) {
    this.total = total;
    this.results = results;
  }

  getTotal() {
    return this.total || 0;
  }

  getPedagogicFakeNewsArticles() {
    const articles = this.results ? Object.values(this.results) : [];
    return articles.map((val) => new DecryptagePedagogicArticle(val));
  }
}
